export const approvalStatusOptions = {
  pending_upload: "等待上傳文件",
  processing: "等待批核中",
  pending_sign: "等待簽署中",
  approved: "已成功批核",
  rejected: "已拒絕",
}
